// import { ReportCategoriesServices } from '@/services/modules/report-categories.service'
import { Filter } from '@/interfaces/filter.interface'
import { APIReportChartType } from '@/models/api/report-chart-type.model'
import { ReportChartTypesServices } from '@/services/modules/report-chart-type.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ReportChartTypesStore extends VuexModule {
    reportChartTypes: object[] = []
    reportcharttypesPaginate: object[] = []
    reportChartTypesForm: object|null = null

    @Mutation
    updateReportChartTypes (newCategories: object[]) {
        this.reportChartTypes = newCategories
    }

    @Mutation
    updateReportChartTypesPaginate (newCategories: object[]) {
        this.reportcharttypesPaginate = newCategories
    }

    @Mutation
    updateReportChartType (newCategory: object) {
        this.reportChartTypesForm = newCategory
    }

    @Action
    getReportChartTypes () {
        return new Promise((resolve) => {
            ReportChartTypesServices.getReportChartTypes()
                .then(resp => {
                    store.commit('updateReportChartTypes', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportChartTypesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }
            ReportChartTypesServices.getReportChartTypesPaginate(newParams)
                .then(resp => {
                    store.commit('updateReportChartTypesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getReportChartTypeById (id: number) {
        return new Promise((resolve) => {
            ReportChartTypesServices.getReportChartTypesById(id)
                .then(resp => {
                    store.commit('updateReportChartType', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editReportChartTypes (params: APIReportChartType) {
        params = new APIReportChartType(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIReportChartType)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ReportChartTypesServices.editReportChartTypes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createReportChartTypes (params: APIReportChartType) {
        params = new APIReportChartType(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIReportChartType)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ReportChartTypesServices.createReportChartTypes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteReportChartTypes (id: number) {
        return new Promise((resolve) => {
            ReportChartTypesServices.deleteReportChartTypes(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
